import { ClassNameProps, Item } from '../../../types/types';
import { paymentsItems } from '../../../data/data';
const ListPayments: React.FC<ClassNameProps> = ({ className }) => {
  return (
    <>
      <ul className={className}>
        {paymentsItems.map((item: Item) => (
          <li key={item.id} className={`${className}__item card`}>
            <div className={`${className}__inner`}>
              <h3 className={`${className}__title subtitle`}>{item.title}</h3>
              <p className={`${className}__text text-normal`}>{item.text}</p>
            </div>
            {item.img && (
              <img
                src={item.img}
                className={`${className}__img`}
                alt={item.title}
              />
            )}
            {item.svg && <>{item.svg}</>}
          </li>
        ))}
      </ul>
    </>
  );
};
export default ListPayments;
